// Shopify names the only variant of a product that has no options "Default Title".
// It is a placeholder, not something to show a shopper.
export const isPlaceholderVariant = (name) =>
  !name || String(name).trim().toLowerCase() === "default title";

// One entry per product_id, keeping the first. The catalog can still hold two records
// for the same Shopify product (see docs/duplicate-products-plan-2026-10-12.md).
export const uniqueVariants = (list) => {
  const seen = new Set();
  return (list || []).filter((v) => v && !seen.has(v.product_id) && seen.add(v.product_id));
};

// Label for a variant button: its own name, or the product title for a placeholder.
export const variantLabel = (v, fallbackName) =>
  isPlaceholderVariant(v.variant_name) ? fallbackName || v.name : v.variant_name;
